import styled from 'styled-components';

export const MissingStyled = styled.main`
  height: 100vh;
  margin-top: 6rem;
  p {
    margin-bottom: 2rem;
  }
`;
